<rk-sidenav-action-wrapper
  [title]="modalTitle"
  (cancelled)="cancelEdit()"
  (submitted)="submit()"
>
  <form *ngIf="editTagForm" (ngSubmit)="submit()" [formGroup]="editTagForm" novalidate>
    <div class="form-fields">
      <div>
        <rk-form-field
          [label]="'PLAYLIST.CREATE_FORM.NAME' | translate"
          [hideCharLimit]="true"
        >
          <input
            data-cy="edit-playlist-name"
            type="text"
            rkInput
            formControlName="name"
            maxlength="150"
            required
          />
          <rk-form-error
            *ngIf="editTagFormErrors.name.required"
            [errorMessage]="'PLAYLIST.CREATE_FORM.TITLE_REQUIRED' | translate"
          ></rk-form-error>
        </rk-form-field>
        <rk-form-field [label]="'PLAYLIST.CREATE_FORM.COLOR' | translate">
          <rk-input-color-picker
            [showWhite]="false"
            formControlName="color"
          ></rk-input-color-picker>
        </rk-form-field>
      </div>
    </div>
  </form>
</rk-sidenav-action-wrapper>
